import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import moment from 'moment';
import { HelpersService } from '../../../../../../services/helpers.service';
import { RentalsService } from '../../../../../../services/rentals.service';
import { MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ReservationProductServiceIndicatorComponent } from '../../reservations/rental-reservation-update/rental-reservation-job-card/reservation-product-service-indicator/reservation-product-service-indicator.component';

@Component({
  selector: 'app-rental-reservation-summary-detail',
  templateUrl: './rental-reservation-summary-detail.component.html',
  styleUrls: ['./rental-reservation-summary-detail.component.scss'],
  providers: [MessageService]
})
export class RentalReservationSummaryDetailComponent implements OnInit {
  @Input() loading: boolean = false;
  @Input() reservationData: any = [];
  @Input() InOrOut: string = '';
  @Input() categories: any = [];
  @Input() brands: any = [];
  @Input() sizes: any = [];
  @Input() rentalStoreRules: any = {};
  @Output() reload = new EventEmitter();

  public partner: any = {};
  public countryData: any = {};
  public expandedReservation: any = {};
  public showRentalReservation: boolean = false;
  public selectedReservation: any = {};
  public currentDate: Date = new Date();
  public reservationStatuses = [
    { key: 1, label: 'Booked In' },
    { key: 2, label: 'Delivery' },
    { key: 10, label: 'Being Prepared' },
    { key: 20, label: 'Ready' },
    { key: 30, label: 'Out' },
    { key: 39, label: 'Collection' },
    { key: 40, label: 'Being Checked' },
    { key: 50, label: 'Returned' },
    { key: 51, label: 'Collected' },
    { key: 100, label: 'Cancel' },
  ];

  constructor(
    private helpersService: HelpersService,
    private rentalService: RentalsService,
    private messageService: MessageService,
    private translate: TranslateService,
    public route: ActivatedRoute,
    public modalService: NgbModal
  ) { }

  ngOnInit() {
    this.partner = this.helpersService.getPartnerData();
    this.countryData = this.helpersService.getCountryData();

    if (this.InOrOut === 'IN') {
      this.route.queryParams.subscribe((params) => {
        console.log(params);
        if (params['reservationID']) {
          this.openReservation({ id: params['reservationID'] });
        }
      });
    }
  }

  ngOnChanges(): void {
    if (this.reservationData) {
      this.reservationData.forEach((reservation) => {
        reservation.duration = this.calculateReservationTime(reservation);
      });
    }
  }

  expandReservation(event: Event, reservation) {
    event.stopPropagation();
    if (reservation.id === this.expandedReservation.id) {
      this.expandedReservation = {};
    } else {
      this.expandedReservation = reservation;
    }
  }

  openReservation(reservation) {
    this.selectedReservation = reservation;
    this.showRentalReservation = true;
  }

  calculateReservationTime(reservation) {
    var timeDiff = moment(reservation.toDate).diff(
      reservation.fromDate,
      'hour',
      false,
    );
    return { days: Math.floor(timeDiff / 24), hours: timeDiff % 24 };
  }

  reloadData() {
    this.reload.emit();
  }

  getProductAccessories(reservation) {
    var accessories = [];
    if (reservation.reservationProducts) {
      reservation.reservationProducts.forEach((x) => {
        if (x.reservationAccessories && x.reservationAccessories.length > 0) {
          x.reservationAccessories.forEach((y) => {
            accessories.push(y);
          });
        }
      });
    }
    return accessories;
  }

  getDate(value) {
    return moment(value).toDate();
  }

  waiversSigned(reservation) {
    if (reservation.reservationProducts) {
      var numberSigned = reservation.reservationProducts
        .map((x) => {
          return x.waiverSigned ? 1 : 0;
        })
        .reduce(this.add, 0);
      return numberSigned === reservation.reservationProducts.length
        ? 'bikeshop.rentals.summary.waiver_signed_all'
        : numberSigned === 0
          ? 'bikeshop.rentals.summary.waiver_signed_none'
          : 'bikeshop.rentals.summary.waiver_signed_partial';
    } else {
      return 'bikeshop.rentals.summary.waiver_signed_none';
    }
  }

  waiversSignedInt(reservation) {
    if (reservation.reservationProducts) {
      var numberSigned = reservation.reservationProducts
        .map((x) => {
          return x.waiverSigned ? 1 : 0;
        })
        .reduce(this.add, 0);
      return numberSigned === reservation.reservationProducts.length
        ? 1
        : numberSigned === 0
          ? 0
          : 2;
    } else {
      return 0;
    }
  }

  add(accumulator, a) {
    return accumulator + a;
  }

  statusClick(event: Event) {
    event.stopPropagation();
  }

  statusUpdated(reservation) {
    var data = {
      ID: reservation.id,
      ReservationStatusID: reservation.reservationStatusID,
      LocalDateTime: moment().format('YYYY-MM-DDTHH:mm:ss'),
    };
    this.rentalService.updateReservationStatus(data).subscribe((response) => {
      this.reload.emit({});
      this.messageService.add({ life: 1000, detail: this.translate.instant("bikeshop.rentals.summary.status_updated") });

      //Check if there are any service indicator records with no value, we need to prompt the user to capture these values
      if (response && response.serviceIndicatorRecords && response.serviceIndicatorRecords.length > 0 && response.serviceIndicatorRecords.filter(x => x.absoluteValue === null || x.absoluteValue < 0).length > 0) {
        const modalRef = this.modalService.open(ReservationProductServiceIndicatorComponent, {
          size: 'lg',
          windowClass: 'jobcard-modal',
          backdrop: true,
        });
        modalRef.componentInstance.serviceIndicatorRecords = response.serviceIndicatorRecords;
        modalRef.componentInstance.reservation = response;
        modalRef.componentInstance.isModal = true;
        modalRef.result.then(
          (result) => {

          },
          (onrejected) => {

          },
        );
      }

    });
  }
}
